import TagManager from 'react-gtm-module';

export const useHomePageTag = ({ label }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'home_page_interaction',
      category: 'UI Interaction',
      action: 'Click',
      label
    }
  });
